const statusNames = {
    new: "Backlog",
    in_progress: "In progress",
    done: "Done"
};

export default statusNames;